import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e2a2b68a")

_pushScopeId("data-v-e2a2b68a")
const _hoisted_1 = { class: "md:flex flex-col md:flex-row md:min-h-screen mt-4 mx-4" }
const _hoisted_2 = {
  class: "md:col-span-1 md:grid-cols-1",
  style: {"display":"unset"}
}
const _hoisted_3 = { class: "mx-auto w-full text-white col-start-3 md:col-span-6 md:grid-cols-6 justify-self-center lg:justify-self-stretch" }
const _hoisted_4 = { class: "mt-7 md:mt-5 lg:mx-auto max-w-4xl" }
const _hoisted_5 = { class: "mx-auto md:max-w-lg lg:max-w-full mt-4" }
const _hoisted_6 = { class: "md:mx-4 lg:mx-12 flex-col sm:flex-row md:items-center md:flex flex-wrap justify-center items-center justify-center" }
const _hoisted_7 = { class: "py-12 md:py-28 lg:py-40 py-auto  transition-transform md:scale-100 sm:hover:scale-110" }
const _hoisted_8 = { class: "text-6xl text-center font-bold text-bp-dark" }
const _hoisted_9 = { class: "text-md text-center font-bold text-bp-dark" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_sidebar_profile = _resolveComponent("sidebar-profile")
  const _component_search = _resolveComponent("search")
  const _component_Filter = _resolveComponent("Filter")
  const _component_default_card_layout = _resolveComponent("default-card-layout")
  const _component_router_link = _resolveComponent("router-link")
  const _component_default_boostpack_card_layout = _resolveComponent("default-boostpack-card-layout")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_sidebar_profile)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", null, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_search)
        ]),
        _createVNode("div", _hoisted_5, [
          _withDirectives(_createVNode(_component_Filter, null, null, 512), [
            [_vShow, false]
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, { to: "/profile/shared/create/" }, {
            default: _withId(() => [
              _createVNode("div", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.open()))
              }, [
                _createVNode(_component_default_card_layout, {
                  "card-padding": "px-6 pb-9",
                  class: "flex-shrink-0 z-0 md:w-96 lg-w-96"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_7, [
                      _createVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("profile.shared.subscribedTitle")), 1),
                      _createVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("profile.shared.itemsUploadedText")), 1)
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_default_boostpack_card_layout, { "enable-edit-boostpack": true })
        ])
      ])
    ])
  ]))
})